import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createBuddyTalktimePlan,
  getAllBuddyTalktimePlans,
  updateBuddyTalktimePlan,
} from '../AkademySlice';
import { Box, Button, IconButton, Modal, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import CustomForm from '../../../components/FormRenderer/CustomForm';

import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';

import { secondsToString } from '../../../utils/helpers';
import { currencyOptions } from '../../../utils/constants';

function AkademyTalktimePlans() {
  const dispatch = useDispatch();
  const { handleLoader } = useLoader();
  const { SuccessToast, ErrorToast } = useToast();

  const { talktimePlans } = useSelector(({ akademyReducer }) => {
    return {
      talktimePlans: akademyReducer.talktimePlans,
    };
  });

  useEffect(() => {
    dispatch(getAllBuddyTalktimePlans());
  }, []);

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (selectedRowId) {
      let selectedPlan = JSON.parse(
        JSON.stringify(talktimePlans.find((item) => item._id === selectedRowId))
      );

      const { name, talktimeInSeconds, prices } = selectedPlan;
      setFormData({ name, talktimeInSeconds, prices });
    } else setFormData({});
  }, [selectedRowId]);

  useEffect(() => {
    const formTemplate = [
      {
        id: 'form.name',
        title: 'Plan Name',
        slug: 'name',
        type: 'String',
        required: true,
      },
      {
        id: 'form.talktimeInSeconds',
        title: 'Talktime (seconds)',
        slug: 'talktimeInSeconds',
        type: 'Number',
        required: true,
      },

      {
        id: 'form.prices',
        title: 'Plan Price',
        slug: 'prices',
        type: 'Array',
        arrayElementType: [
          {
            id: 'form.prices.currency',
            title: 'Currency',
            slug: 'currency',
            type: 'AutoCompleteSelect',
            options: currencyOptions,
            required: true,
          },
          {
            id: 'form.prices.amount',
            title: 'Amount',
            slug: 'amount',
            type: 'Number',
            required: true,
          },
        ],
        required: true,
      },
    ];
    setFormTemplate(formTemplate);
  }, []);

  const talktimePlanColumns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Talktime',
      accessor: 'talktimeInSeconds',
      Cell: (val) => {
        const { talktimeInSeconds } = val.cell.row.original;

        return <Typography>{secondsToString(talktimeInSeconds)}</Typography>;
      },
    },
    {
      Header: 'Prices',
      accessor: 'prices.amount',
      Cell: (val) => {
        const { prices } = val.cell.row.original;

        return (
          <>
            {prices.map(({ currency, amount }) => (
              <Typography>
                {currency} - {amount},
              </Typography>
            ))}
          </>
        );
      },
    },
    {
      Header: 'Edit',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleSave = async () => {
    const payload = formData;

    dispatch(
      selectedRowId === null
        ? createBuddyTalktimePlan(payload)
        : updateBuddyTalktimePlan({
            id: selectedRowId,
            data: payload,
          })
    )
      .unwrap()
      .then((res) => {
        SuccessToast(res.message);
        dispatch(getAllBuddyTalktimePlans());
        closeFormModal();
      })
      .catch((error) => {
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box>
      <Button onClick={handleCreateNew} variant={'contained'} color="primary">
        Add Talktime Plan
      </Button>
      <Box my={2}>
        <BuzzTable
          columns={talktimePlanColumns}
          data={talktimePlans}
          // isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={() => setFormModal(false)}>
        <>
          {' '}
          <CustomForm
            formFor={'Talktime Plan'}
            formTemplate={formTemplate}
            formData={formData}
            setFormData={(slug, newValue) => {
              setFormData((state) => {
                state[slug] = newValue;
                return state;
              });
              setFormTemplate((state) => {
                return JSON.parse(JSON.stringify(state));
              });
            }}
            mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
            handleSave={handleSave}
            width={600}
          />
        </>
      </Modal>
    </Box>
  );
}

export default AkademyTalktimePlans;
